import { render, staticRenderFns } from "./ComplianceAssistantPage.vue?vue&type=template&id=b7f61d12&scoped=true"
import script from "./ComplianceAssistantPage.vue?vue&type=script&lang=js"
export * from "./ComplianceAssistantPage.vue?vue&type=script&lang=js"
import style0 from "./ComplianceAssistantPage.vue?vue&type=style&index=0&id=b7f61d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f61d12",
  null
  
)

export default component.exports